if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButtonSuccessTimeout = null;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.updateQuantityOptionsFromCart();
        ProductForm.bindQualidooBundleQuantityRefresh();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.refreshCartAfterPartialAdd();

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            this.showSuccessText();

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }

            this.updateQuantityOptionsFromCart();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }


      refreshCartAfterPartialAdd() {
        if (!this.cart || typeof this.cart.getSectionsToRender !== 'function') return;

        const sectionIds = this.cart.getSectionsToRender().map((section) => section.id).join(',');

        fetch(`${window.location.pathname}?sections=${sectionIds}`)
          .then((response) => response.json())
          .then((sections) => {
            if (!sections) return;

            this.cart.classList.remove('is-empty');
            this.cart.querySelector('.drawer__inner')?.classList.remove('is-empty');
            this.cart.querySelector('cart-drawer-items')?.classList.remove('is-empty');

            if (typeof this.cart.renderContents === 'function') {
              this.cart.renderContents({ sections });
            }

            this.updateQuantityOptionsFromCart();
          })
          .catch((error) => console.error(error));
      }

      updateQuantityOptionsFromCart() {
        const select = this.form?.querySelector('select[name="quantity"]');
        const variantId = Number(this.variantIdInput?.value || new FormData(this.form).get('id'));

        if (!select || !variantId) return;

        if (!select.dataset.qualidooOriginalMax) {
          const originalMax = Math.max(
            ...Array.from(select.options).map((option) => Number(option.value) || 0),
            1
          );
          select.dataset.qualidooOriginalMax = String(originalMax);
        }

        const originalPerAddMax = Number(select.dataset.qualidooOriginalMax || 1);
        const inventoryMax = this.getQualidooInventoryMaxForVariant(variantId);

        if (!inventoryMax || inventoryMax >= 9999) return;

        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then((cart) => {
            const alreadyInCart = (cart.items || [])
              .filter((item) => Number(item.variant_id) === variantId)
              .reduce((sum, item) => sum + item.quantity, 0);

            const remaining = Math.max(inventoryMax - alreadyInCart, 0);
            const visibleMax = Math.min(remaining, originalPerAddMax);
            const previousValue = Number(select.value || 1);

            select.innerHTML = '';

            if (visibleMax > 0) {
              for (let quantity = 1; quantity <= visibleMax; quantity += 1) {
                const option = document.createElement('option');
                option.value = String(quantity);
                option.textContent = String(quantity);
                if (quantity === Math.min(previousValue, visibleMax)) option.selected = true;
                select.appendChild(option);
              }

              select.disabled = false;
              if (!this.submitButton.classList.contains('loading')) {
                this.submitButton.disabled = false;
                this.submitButton.removeAttribute('aria-disabled');
              }
              if (this.submitButtonText && this.submitButtonText.dataset.qualidooOriginalText) {
                this.submitButtonText.textContent = this.submitButtonText.dataset.qualidooOriginalText;
              }
            } else {
              const option = document.createElement('option');
              option.value = '1';
              option.textContent = '0';
              option.selected = true;
              select.appendChild(option);
              select.disabled = true;

              if (this.submitButtonText) {
                this.submitButtonText.dataset.qualidooOriginalText =
                  this.submitButtonText.dataset.qualidooOriginalText || this.submitButtonText.textContent.trim();
                this.submitButtonText.textContent = 'Nicht mehr verfügbar';
              }

              this.submitButton.disabled = true;
              this.submitButton.setAttribute('aria-disabled', 'true');
            }
          })
          .catch((error) => console.error(error));
      }

      getQualidooInventoryMaxForVariant(variantId) {
        let inventoryMax = Number(
          this.form?.dataset?.inventoryMax ||
            this.dataset.inventoryMax ||
            this.form?.querySelector('select[name="quantity"]')?.dataset?.inventoryMax ||
            0
        );

        document.querySelectorAll('[data-qualidoo-bundle-add]').forEach((button) => {
          if (Number(button.dataset.mainVariantId) === variantId) {
            inventoryMax = Number(button.dataset.mainMaxQuantity || inventoryMax || 0);
          }

          if (Number(button.dataset.bundleVariantId) === variantId) {
            inventoryMax = Number(button.dataset.bundleMaxQuantity || inventoryMax || 0);
          }
        });

        return inventoryMax;
      }

      static bindQualidooBundleQuantityRefresh() {
        if (window.__qualidooBundleQuantityRefreshBound) return;
        window.__qualidooBundleQuantityRefreshBound = true;

        const refreshProductForms = () => {
          document.querySelectorAll('product-form').forEach((productForm) => {
            if (typeof productForm.updateQuantityOptionsFromCart === 'function') {
              productForm.updateQuantityOptionsFromCart();
            }
          });
        };

        document.addEventListener('click', (event) => {
          if (!event.target.closest('[data-qualidoo-bundle-add]')) return;
          window.setTimeout(refreshProductForms, 900);
          window.setTimeout(refreshProductForms, 2200);
        });

        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) refreshProductForms();
        });
      }

      showSuccessText() {
        if (!this.submitButton) return;

        const textElement = this.submitButtonText || this.submitButton.querySelector('span') || this.submitButton;
        const originalText = textElement.dataset.originalText || textElement.textContent.trim();

        textElement.dataset.originalText = originalText;
        textElement.classList.remove('hidden');
        textElement.textContent = originalText;
        this.submitButton.classList.remove('product-form__submit--success');

        window.clearTimeout(this.submitButtonSuccessTimeout);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
